module.exports = __webpack_public_path__ + "static/media/oval-2-copy-7@1x.9b73995f.png";